import { Controller, useFormContext } from 'react-hook-form'

import { FF2, TextInput } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

export const PhoneExt = ({ index1, index2 }: { index1: number; index2: number }) => {
  const { control } = useFormContext<SarEdit>()

  return (
    <Controller
      name={`subjectsInfo.${index1 as 0}.phoneNumbers.${index2 as 0}.phoneExt`}
      control={control}
      render={({ field }) => (
        <FF2 field={field} label="Ext." input={(props) => <TextInput {...props} maxLength={6} />} />
      )}
    />
  )
}
